import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=f815bb0e&scoped=true&lang=pug&"
import script from "./Challenge.vue?vue&type=script&lang=ts&"
export * from "./Challenge.vue?vue&type=script&lang=ts&"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=f815bb0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f815bb0e",
  null
  
)

export default component.exports